import React from 'react';
import { useIntl } from 'react-intl';
import { Container } from 'reactstrap';
import { StyledSlideWrapper, StyledGridBlockCard, StyledGridContainer, StyledPlayIcon } from './styledLogoSlideBlock';
import { ILogoSlideBlock } from './types';
import messages from './messages';

const LogoSlideBlock = ({ title, logos }: ILogoSlideBlock): JSX.Element => {
  const { formatMessage, locale } = useIntl();

  return (
    <StyledSlideWrapper>
      <Container>
        <p>{title}</p>
        <StyledGridContainer>
          {logos.map(({ logo, demoLink, isComingSoon }) => (
            <StyledGridBlockCard key={logo.image.file}>
              <img className="partner-logo" src={logo.image.file} alt={logo.altText} />
              {isComingSoon && <span className="logo-status">— {formatMessage(messages.statusComingSoon)} —</span>}
              {/* TODO: Demo function yet to be finalized */}
              {!isComingSoon && demoLink && (
                <a className="logo-status" href={`/${locale}${demoLink}`} target="_blank" rel="noopener noreferrer">
                  <StyledPlayIcon />
                  {formatMessage(messages.statusDemo)}
                </a>
              )}
            </StyledGridBlockCard>
          ))}
        </StyledGridContainer>
      </Container>
    </StyledSlideWrapper>
  );
};

export default LogoSlideBlock;
